import React from 'react'
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { forgetpwdValidation } from './Validation';
import { useDispatch, useSelector } from 'react-redux';
import { changePassword, popUp } from '../Redux/Auth/AuthSlice';
import { Notify } from '../CommonPopup/Popup';
import Spinner from '../Spinner/Spinner';


const schema = forgetpwdValidation

const ForgetPwd = () => {
  const selector = useSelector((s) => s.AuthSlice)
  const loader = selector.loader
  const dispatch = useDispatch()
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    reset()
    dispatch(changePassword(data))
    .unwrap().then((data) => {
      console.log("data------", data);
      if (data.success === true) {
        // localStorage.setItem("token")
        Notify({ data: "success", msg: data.message })

      } else {
        Notify({ data: "error", msg: data.message })
      }

      setTimeout(() => {
        dispatch(popUp(false))

      }, 5000);
    })

  };

  return (
    <div>
      <div className='container mt-5 '>
        <h2 className='fw-bold'>Forget Password</h2>
        {loader ? <Spinner/>: 
         <form onSubmit={handleSubmit(onSubmit)} className=' form-group shadow shadow-lg w-25 m-auto p-4 py-4 mt-4'>



         <Controller
           name="email"
           control={control}
           defaultValue=""
           render={({ field }) => (
             <TextField
               label="Email"
               className='form-group'
               fullWidth
               variant="outlined"
               error={!!errors.email}
               helperText={errors.email?.message}
               {...field}
             />
           )}
         />

         <Button className='mt-3' type="submit" variant="contained" color="primary">
           Forget Password
         </Button>
       </form>}
       
      </div>
    </div>
  )
}

export default ForgetPwd
